import { gql } from 'urql'

// Feature Config with sorting queries
export const queryFeatureSortingConfigs = gql`
  query fetchFeatureSortingConfigs(
    $featureSortingConfigWhere: feature_sorting_config_bool_exp!
    $ftSortingConfigWhere: feature_type_sorting_config_bool_exp!
    $fgSortingConfigWhere: feature_group_sorting_config_bool_exp
  ) {
    feature_sorting_config(where: $featureSortingConfigWhere, order_by: { sort_order: asc }) {
      id
      sort_order
      process
      level
      feature_config {
        id
        code
        feature_type_id
        feature_group_id
        levels

        feature_sorting_configs(where: $featureSortingConfigWhere, order_by: { sort_order: asc }) {
          id
          sort_order
          feature_config_id
        }

        feature_type_sorting_configs(where: $ftSortingConfigWhere, order_by: { sort_order: asc }) {
          id
          level
          process
          sort_order
          feature_type_config {
            code
            names
          }
        }

        feature_group_sorting_configs(where: $fgSortingConfigWhere, order_by: { sort_order: asc }) {
          id
          sort_order
          feature_group_config {
            code
            names
          }
        }

        names
        tooltips
        processes
        selection_type
        active
      }
    }
  }
`

export const queryFeatureTypeSortingConfigs = gql`
  query fetchFeatureTypeSortingConfigs($featureTypeSortingConfigWhere: feature_type_sorting_config_bool_exp!) {
    feature_type_sorting_config(where: $featureTypeSortingConfigWhere, order_by: { sort_order: asc }) {
      id
      level
      process
      feature_type_config {
        id
        names
        description
        code
        has_kap_factsheet_validation
        active
        help_and_instruction_key

        feature_type_sorting_configs(where: $featureTypeSortingConfigWhere, order_by: { sort_order: asc }) {
          feature_type_config_id
          id
          sort_order
        }
      }
    }
  }
`

export const queryFeatureGroupSortingConfig = gql`
  query fetchFeatureGroupSortingConfigs($featureGroupSortingConfigWhere: feature_group_sorting_config_bool_exp!) {
    feature_group_sorting_config(where: $featureGroupSortingConfigWhere, order_by: { sort_order: asc }) {
      id
      level
      process
      sort_order
      feature_group_config {
        names
        code
        id
        feature_type_id
        active

        feature_group_sorting_configs(where: $featureGroupSortingConfigWhere, order_by: { sort_order: asc }) {
          id
          sort_order
          feature_group_config_id
        }
      }
    }
  }
`

export const queryFeatureValuesByFeatureSortingConfig = gql`
  query fetchFeatureValues(
    $featureBaseWhere: feature_base_bool_exp!
    $featureSortingConfigWhereForSort: feature_sorting_config_bool_exp!
  ) {
    feature_value(where: { feature_base: $featureBaseWhere }) {
      feature_config_id
      other_description

      feature_sorting_configs(where: $featureSortingConfigWhereForSort, order_by: { sort_order: asc }) {
        id
        sort_order
        feature_config {
          id
          code
          feature_type_id
          feature_group_id
          names
          tooltips
          processes
          selection_type
          active
          levels
        }
      }
    }
  }
`

export const queryFeatureConfigs = gql`
  query fetchFeatureConfigs($featureConfigWhere: feature_config_bool_exp!) {
    feature_config(where: $featureConfigWhere) {
      id
      code
      feature_type_id
      feature_type_config {
        sort_number
        code
        names
      }
      names
      tooltips
      processes
      selection_type
      active
    }
  }
`

export const queryFeatureConfigsSorting = gql`
  query fetchFeatureConfigs(
    $featureConfigWhere: feature_config_bool_exp!
    $featureSortingConfigWhere: feature_sorting_config_bool_exp!
    $featureTypeSortingConfigWhere: feature_type_sorting_config_bool_exp!
    $featureGroupSortingConfigWhere: feature_group_sorting_config_bool_exp
  ) {
    feature_config(where: $featureConfigWhere) {
      id
      code
      feature_sorting_configs(where: $featureSortingConfigWhere, order_by: { sort_order: asc }) {
        sort_order
      }
      feature_type_id
      feature_group_id

      feature_group_config {
        feature_group_sorting_configs(where: $featureGroupSortingConfigWhere, order_by: { sort_order: asc }) {
          sort_order
        }
      }

      feature_type_config {
        feature_type_sorting_configs(where: $featureTypeSortingConfigWhere, order_by: { sort_order: asc }) {
          sort_order
        }
        code
        names
      }
      names
      tooltips
      processes
      selection_type
      active
    }
  }
`

export const queryFeatureConfigsSortedByName = gql`
  query fetchFeatureConfigs($featureConfigWhere: feature_config_bool_exp!) {
    feature_config(where: $featureConfigWhere, order_by: [{ feature_type_config: { names: asc } }, { names: asc }]) {
      id
      code
      feature_type_id
      feature_type_config {
        code
        names
      }
      feature_group_id
      feature_group_config {
        code
        names
      }
      names
      tooltips
      processes
      selection_type
      active
    }
  }
`

export const queryFeatureBase = gql`
  query fetchFeatureBase($featureBaseWhere: feature_base_bool_exp!, $featureTypeId: Int!) {
    feature_base(where: $featureBaseWhere) {
      id
      feature_values(where: { feature_config: { feature_type_id: { _eq: $featureTypeId } } }) {
        other_description
        feature_config {
          id
          names
          selection_type
          code
          tooltips
          active
          levels
          feature_group_id
          feature_group_config {
            names
            code
          }
          feature_type_config {
            description
          }
        }
      }
    }
  }
`

export const queryFeatureTypesSorting = gql`
  query fetchFeatureConfigs($fTSortingConfigWhere: feature_type_sorting_config_bool_exp) {
    feature_type_config {
      id
      names
      feature_type_sorting_configs(where: $fTSortingConfigWhere, order_by: { sort_order: asc }) {
        sort_order
      }
      description
      code
      has_kap_factsheet_validation
    }
  }
`

export const queryFeatureGroupSorting = gql`
  query fetchFeatureConfigs($fGSortingConfigWhere: feature_group_sorting_config_bool_exp) {
    feature_group_config {
      id
      names
      feature_group_sorting_configs(where: $fGSortingConfigWhere, order_by: { sort_order: asc }) {
        sort_order
      }

      code
    }
  }
`

export const queryFeatureTypesSortedByName = gql`
  query fetchFeatureConfigs {
    feature_type_config(order_by: { names: asc }) {
      id
      names
      description
      code
      has_kap_factsheet_validation
    }
  }
`

export const queryFeatureGroupsSortedByName = gql`
  query fetchFeatureConfigs {
    feature_group_config(order_by: { names: asc }) {
      id
      names
      code
    }
  }
`
export const queryFeaturesByFeatureType = gql`
  query fetchFeaturesByFeatureType(
    $featureType: Int!
    $featureConfigWhere: feature_config_bool_exp!
    $featureSortingConfigWhere: feature_sorting_config_bool_exp!
    $featureGroupSortingConfigWhere: feature_group_sorting_config_bool_exp
  ) {
    feature_config(where: { _and: [{ feature_type_config: { id: { _eq: $featureType } } }, $featureConfigWhere] }) {
      id
      feature_group_id
      code
      names
      tooltips
      selection_type
      levels

      feature_sorting_configs(where: $featureSortingConfigWhere, order_by: { sort_order: asc }) {
        sort_order
      }

      active

      feature_group_config {
        feature_group_sorting_configs(where: $featureGroupSortingConfigWhere, order_by: { sort_order: asc }) {
          sort_order
        }

        code
        names
      }
    }

    feature_type_config(where: { id: { _eq: $featureType } }) {
      names
      description
      code
      has_kap_factsheet_validation
    }
  }
`

export const queryFeatureBaseValuesWithKPIs = gql`
  query FetchFeatureBaseValuesWithKPIs(
    $projectBaseQuery: project_base_bool_exp
    $featureConfigKPIWhere: feature_config_bool_exp
    $featureTypeSortingConfig: feature_type_sorting_config_bool_exp!
    $featureGroupSortingConfig: feature_group_sorting_config_bool_exp!
    $featureSortingConfig: feature_sorting_config_bool_exp!
  ) {
    feature_base(where: { project_base: $projectBaseQuery }) {
      id
      feature_values(where: { feature_config: $featureConfigKPIWhere }) {
        id
        feature_config_id
        other_description
        feature_config {
          code
          names
          tooltips
          feature_sorting_configs(where: $featureSortingConfig, order_by: { sort_order: asc }) {
            sort_order
          }

          feature_group_config {
            feature_group_sorting_configs(where: $featureGroupSortingConfig, order_by: { sort_order: asc }) {
              sort_order
            }
          }

          feature_type_config {
            feature_type_sorting_configs(where: $featureTypeSortingConfig, order_by: { sort_order: asc }) {
              sort_order
            }
            code
            names
          }
        }
        feature_kpi {
          id
          target
        }
      }
    }
  }
`

// insert / update queries
export const bulkSaveFeatures = gql`
  mutation ($featureBaseId: Int!, $featuresToBeAdded: [feature_value_insert_input!]!, $featuresToBeDeleted: [Int!]) {
    delete_feature_value(
      where: { feature_config_id: { _in: $featuresToBeDeleted }, feature_base: { id: { _eq: $featureBaseId } } }
    ) {
      affected_rows
    }

    insert_feature_value(
      objects: $featuresToBeAdded
      on_conflict: {
        constraint: feature_value_feature_config_id_feature_base_id_uq
        update_columns: other_description
        where: { feature_base: { id: { _eq: $featureBaseId } } }
      }
    ) {
      affected_rows
    }
  }
`
export const bulkSaveProjectFeatureKpis = gql`
  mutation ($featureKpis: [feature_kpi_insert_input!]!) {
    insert_feature_kpi(
      objects: $featureKpis
      on_conflict: { constraint: feature_kpi_feature_value_id_uq, update_columns: target }
    ) {
      affected_rows
    }
  }
`

// sorting update
export const updateSortOnFeatureTypeConfig = gql`
  mutation UpdateTwoFeatureTypeSortConfig(
    $firstWhere: feature_type_sorting_config_bool_exp!
    $secondWhere: feature_type_sorting_config_bool_exp!
    $setClause1: feature_type_sorting_config_set_input!
    $setClause2: feature_type_sorting_config_set_input!
  ) {
    updateFirst: update_feature_type_sorting_config(where: $firstWhere, _set: $setClause1) {
      affected_rows
    }
    updateSecond: update_feature_type_sorting_config(where: $secondWhere, _set: $setClause2) {
      affected_rows
    }
  }
`

export const updateSortOnFeatureGroupConfig = gql`
  mutation UpdateTwoFeatureGroupSortConfig(
    $firstWhere: feature_group_sorting_config_bool_exp!
    $secondWhere: feature_group_sorting_config_bool_exp!
    $setClause1: feature_group_sorting_config_set_input!
    $setClause2: feature_group_sorting_config_set_input!
  ) {
    updateFirst: update_feature_group_sorting_config(where: $firstWhere, _set: $setClause1) {
      affected_rows
    }
    updateSecond: update_feature_group_sorting_config(where: $secondWhere, _set: $setClause2) {
      affected_rows
    }
  }
`

export const updateSortOnFeatureConfig = gql`
  mutation UpdateTwoFeatureSortConfig(
    $firstWhere: feature_sorting_config_bool_exp!
    $secondWhere: feature_sorting_config_bool_exp!
    $setClause1: feature_sorting_config_set_input!
    $setClause2: feature_sorting_config_set_input!
  ) {
    updateFirst: update_feature_sorting_config(where: $firstWhere, _set: $setClause1) {
      affected_rows
    }
    updateSecond: update_feature_sorting_config(where: $secondWhere, _set: $setClause2) {
      affected_rows
    }
  }
`
